import React, { PropTypes } from 'react';
import { isArray, cond } from 'lodash';

const If = ({ children, condition, className = '' }) =>
    cond([
        [() => !condition, () => null],
        [() => isArray(children), () => <div className={className}>{children}</div>],
        [() => true, () => children]
    ])();

If.propTypes = {
    children: PropTypes.element.isRequired,
    condition: PropTypes.bool
};

export default If;



// WEBPACK FOOTER //
// ./src/components/helpers/if.js